import DatesConfig from '@/configs/dates';

export const mixinDatesHandler = {
  methods: {
    _mixinDateHandler_ApiResponseDateTimeToFormat(date, toFormat, utc) {
      if (utc) {
        return this.$moment.utc(date, DatesConfig.API_RESPONSE_DATE_TIME_FORMAT).tz(DatesConfig.UI_TIME_ZONE).format(toFormat);
      }

      return this.$moment(date, DatesConfig.API_RESPONSE_DATE_TIME_FORMAT).tz(DatesConfig.UI_TIME_ZONE).format(toFormat);
    },

    _mixinDateHandler_ApiResponseDateFromNow(date, utc) {
      if (utc) {
        return this.$moment.utc(date, DatesConfig.API_RESPONSE_DATE_TIME_FORMAT).tz(DatesConfig.UI_TIME_ZONE).fromNow();
      }

      return this.$moment(date, DatesConfig.API_RESPONSE_DATE_TIME_FORMAT).tz(DatesConfig.UI_TIME_ZONE).fromNow();
    },

    _mixinDateHandler_IsValidDate(date, fromFormat) {
      if (!fromFormat) {
        fromFormat = DatesConfig.API_RESPONSE_DATE_TIME_FORMAT;
      }

      return this.$moment.utc(date, fromFormat).isValid();
    },

    _mixinDateHandler_GetTimeZoneAbbr() {
      return this.$moment.tz(DatesConfig.UI_TIME_ZONE).zoneAbbr();
    },
  },
};
